var map = {
	"./agenda-asesorias.png": 10284,
	"./api.png": 90167,
	"./contenido-web.png": 46835,
	"./dashboard-lecciones.png": 38219,
	"./estadisticas.png": 34734,
	"./gestion-apariencia.png": 66462,
	"./gestion-aula-virtual.png": 22916,
	"./gestion-banco-preguntas.png": 20290,
	"./gestion-consejos-rapidos.png": 8618,
	"./gestion-contenido-cursos.png": 60056,
	"./gestion-foro-ayuda.png": 38664,
	"./gestion-lecciones.png": 96346,
	"./gestion-licencias.png": 16412,
	"./gestion-notificaciones.png": 80361,
	"./gestion-rutas-aprendizaje.png": 75236,
	"./gestion-usuarios.png": 57238,
	"./info.png": 80355,
	"./nuevo-estudiante.png": 42993,
	"./plantillas-trabajo.png": 14297,
	"./security.png": 81957,
	"./suiteIa.png": 14865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53303;